<template>
  <div class="myfooter">
    <div class="user-details">
      <label>User : {{ userName }}</label>
    </div>
    <div class="version">Version:{{ $store.state.version }}</div>
  </div>
</template>
<script>
export default {
  data() {
    return {
      userName: this.$store.state.userObj.ename,
    };
  },
};
</script>

<style scoped>
.myfooter {
  position: fixed;
  display: block;
  width: 100%;
  height: 25px;
  background-color: white;
  bottom: 0px;
  padding: 0px;
  box-shadow: 1px 0px 5px 2px lightgray;
  z-index: 10;
}
.user-details {
  position: relative;
  display: inline-block;
  left: 10px;
  margin: 2px;
  padding: 0px;
  font-size: 12px;
}
.user-details label {
  position: relative;
  font-weight: bold;
  margin: 0px;
  padding: 0px;
}
.version {
  position: relative;
  display: inline-block;
  float: right;
  right: 10px;
  margin-top: 4px;
  padding: 0px;
  font-size: 12px;
  font-weight: bolder;
}
</style>
